import { FuseConfig } from './../../@fuse/types';

/**
 * Default Fuse Configuration
 *
 * You can edit these options to change the default options. All these options also can be
 * changed per component basis. See `app/main/pages/authentication/login/login.component.ts`
 * constructor method to learn more about changing these options per component basis.
 */

export const fuseConfig: FuseConfig = {
    // Color themes can be defined in src/app/app.theme.scss
    colorTheme: 'theme-ecap',
    preventScrollTop: false,
    customScrollbars: true,
    workingDomain: "",
    layout: {
        style: 'vertical-layout-1',
        width: 'fullwidth',
        zoomControl: false,
        navbar: {
            primaryBackground: 'fuse-navy-700',
            secondaryBackground: 'fuse-navy-900',
            folded: false,
            hidden: true,
            userNameShow: true,
            designationShow: false, // do not use it, we will remove it in close future.
            designationText: '',
            position: 'left',
            variant: 'vertical-style-1',
            laftNavigationTopLogo: "https://cdn.selise.biz/swisspartners/Logo/logo_login_256.png",
            navbarTop: 'spp-nav-tool',
            background: 'select-sidenav-color',
            userProfileDefaultImage: '',
            topMenu: {
                showMyAccount: true,
                showAbout: true,
                showMemory: true,
                showLogout: true,
                logoutIcon: 'exit_to_app',
                newMenuList: []
            }
        },
        topBarUserMenu: {
            hidden: true
        },
        toolbar: {
            customBackgroundColor: false,
            background: 'fuse-white-500',
            hidden: true,
            position: 'below-static',
            component: {
                shortcuts: true,
                search: true,
                userInfo: true,
                userMenu: {
                    showProfile: true,
                    clickOnProfileEvent: null,
                    showMail: true
                },
                sudebar: true,
                rightLogo: "",
                languageMenu: {
                    show: true,
                    showLearnMore: true,
                    showFlag: true
                }
            }
        },
        footer: {
            customBackgroundColor: true,
            background: 'fuse-navy-900',
            hidden: true,
            position: 'below-fixed'
        },
        sidepanel: {
            hidden: true,
            position: 'right'
        },
        breadcrumb: false,
        progressbar: {
            theme: 'accent'
        },
        quickpanel: {
            hidden: false
        }
    },
    app: {
        login: {
            loginformTopLogo: "https://cdn.selise.biz/swisspartners/Logo/logo_login_256.png"
        }
    }
};
